import Vuex from 'vuex';
import comments from './comments';
import notifications from './notifications';
import overtime from './overtime';
import users from './users';
import serviceReminders from './serviceReminders';
import resourceCalendar from "./resourceCalendar";

const store = new Vuex.Store({
    modules: {
        comments,
        notifications,
        overtime,
        users,
        serviceReminders,
        resourceCalendar,
    },
    state: {
        errors: {},
        errorMessage: null,
        infoMessage: null,
        isLoading: false,
        isSaving: false,
        pageTitle: null,
    },
    mutations: {
        setErrors (state, errors) {
            state.errors = errors;
        },

        clearErrors (state) {
            state.errors = {};
            state.errorMessage = null;
        },

        setErrorMessage(state, message) {
            state.errorMessage = message;
        },

        clearErrorMessage(state) {
            state.errorMessage = null;
        },

        setInfoMessage(state, message) {
            state.infoMessage = message;
        },

        clearInfoMessage(state) {
            state.infoMessage = null;
        },

        setSaving(state) {
            state.isSaving = true;
            state.infoMessage = 'Saving, please wait...';
        },

        clearSaving(state) {
            state.isSaving = false;
            state.infoMessage = null;
        },

        setLoading(state) {
            state.isLoading = true;
            state.infoMessage = 'Loading, please wait...';
        },

        clearLoading(state) {
            state.isLoading = false;
            state.infoMessage = null;
        },

        setPageTitle(state, title) {
            state.pageTitle = title;
        }
    }
});

export default store;


// WEBPACK FOOTER //
// ./resources/assets/js/store/index.js